import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, INVITE } from 'src/api';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';

export function useInviteMultipleUsersMutation() {
  const queryClient = useQueryClient();

  const { mutate: inviteMultiple } = useMutation({
    mutationFn: (ids: string[]) => {
      const users = ids.map((id: string) => ({ user: id }));
      return axios.post(`${API_URL}${INVITE}`, users);
    },
    onSuccess: (response) => {
      const emailsPerMinuteLimit = 5;
      if (response.data.data.length > emailsPerMinuteLimit) {
        const hours = Math.ceil(
          response.data.data.length / (emailsPerMinuteLimit * 60),
        );
        if (hours === 1) {
          handleSuccessToast({
            toastMessage: `Sending started, will complete in approximately one hour.`,
          });
        } else {
          handleSuccessToast({
            toastMessage: `Sending started, will complete in approximately ${hours} hours.`,
          });
        }
      } else {
        handleSuccessToast({ toastMessage: 'User Invited Successfully' });
      }
      queryClient.invalidateQueries('SearchUsersPaginated');
    },
    onError: () => {
      handleErrorToast({ toastMessage: 'User invitation failed' });
    },
  });

  return inviteMultiple;
}
